type BlogsListProps = {
    tab: string,
    setTab: (tab: string) => void,
}
export default function BlogsList({tab, setTab} : BlogsListProps){
    return (
        <div className="min-h-screen bg-slate-50">
            <button onClick={() => setTab("Blog detail")}>Create</button>
        </div>
    )
}